import { Api } from "./api.service";

const STORAGE_KEY = "CAMPUS_SYSTEM_CONFIG";

/**
 * Загрузка конфигурации системы с сервера
 * GET /storage/by-key?key=system-config
 * Возвращает объект вида:
 * {
 *   "system-name": "БГПУ",
 *   "modules": ["rating", "exam", "labels", "keys", "events", "personal-area", "bot"]
 * }
 */
async function loadConfig() {
  try {
    const response = await Api.get("/storage/by-key", {
      params: { key: "system-config" }
    });

    if (response && response.value) {
      const config = JSON.parse(response.value);
      localStorage.setItem(STORAGE_KEY, JSON.stringify(config));
      return config;
    }

    return null;
  } catch (error) {
    console.error("Ошибка загрузки конфигурации системы:", error);
    return null;
  }
}

/**
 * Получение конфигурации из localStorage
 */
function getConfig() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

/**
 * Получение названия системы
 */
function getSystemName() {
  const config = getConfig();
  return config && config["system-name"] ? config["system-name"] : "";
}

/**
 * Проверка доступности модуля
 * @param {string} moduleName - название модуля (rating, exam, labels, keys, events, personal-area, bot)
 * @returns {boolean}
 */
function isAvailableModule(moduleName) {
  const config = getConfig();
  if (!config || !Array.isArray(config.modules)) {
    return false;
  }
  return config.modules.includes(moduleName);
}

/**
 * Обновление конфигурации системы
 * PUT /storage/{id}
 * @param {number|null} storageId - id записи storage (null если нужно создать новую)
 * @param {string} value - JSON строка с конфигурацией
 */
async function updateConfig(storageId, value) {
  const { Api } = await import("@/services/api.service");

  if (storageId) {
    return Api.put(`/storage/${storageId}`, {
      key: "system-config",
      value
    });
  } else {
    return Api.post("/storage", {
      key: "system-config",
      value
    });
  }
}

export {
  loadConfig,
  getConfig,
  getSystemName,
  isAvailableModule,
  updateConfig
};
